/**
 * 区块标题杆左侧的三角。
 *
 * 抽出来是因为「页面内容」和「页头页脚」两处都要它，而它的形状（12px 箭头、
 * 2.4 的描边）和外面的色块是**一整套**观感：改一处不改另一处，两页的开关
 * 就会一个粗一个细，客户会以为是两种不同的操作。
 *
 * 颜色与展开/收起两态都在 CSS 里（`.block-head__chevron`，按父按钮的
 * `aria-expanded` 切换），这里只画形状 —— 所以它是纯展示件，不带 props。
 */
export function BlockChevron() {
  return (
    <span className="block-head__chevron" aria-hidden="true">
      <svg viewBox="0 0 16 16" width="12" height="12" focusable="false">
        <path
          d="M6 3.4 10.6 8 6 12.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
